module.exports = __webpack_public_path__ + "files/bbf0572b186ace7620500347d634fbee.png";